import { IApplicationState } from '../../types/redux';

export const selectSubdomainRegionId = (state: IApplicationState): number => {
  return state.mainpage.regionsData.subdomainRegionId;
};
